import {
  Content,
  HeaderLogo,
  PageLayoutFooter,
  PlanoLogo,
  TextDisplay,
} from '@angeplus/prever-component-lib';
import styled from '@emotion/styled';
import { LocationStateSelect } from '@angeplus/prever-component-lib/nextjs';
import { PAGE_TITLE } from '../../utils/pageTitle';
import {
  AboutAngeplusPlatform,
  Faq,
  HideAndMeetAngeplus,
  Panel,
} from './components';
import { TalkWithConsultant } from './components/TalkWithConsultant';
import { PlanVersionsList } from '../catalog/PlanVersionsList';
import { PlansFeatures } from '../catalog/PlansFeatures';

export const PlansLandingPage = () => {
  return (
    <PageLayoutFooter title={PAGE_TITLE.defaultTitle}>
      <LocationStateSelect displayHomeButton />
      <Content>
        <HeaderLogo image={<PlanoLogo />} />
        <AlignStart>
          <TextDisplay>
            Seu plano de assistências, seguros e benefícios
          </TextDisplay>
        </AlignStart>
        <PlanVersionsList />
        <TalkWithConsultant />
        <PlansFeatures />
        <AboutAngeplusPlatform />
        <Panel />
        <HideAndMeetAngeplus />
        <Faq />
      </Content>
    </PageLayoutFooter>
  );
};

const AlignStart = styled.div`
  align-self: flex-start;
`;
